import React from 'react';
import { Check, Close, HourglassEmpty } from '@mui/icons-material';

import { BaseStatusChip } from '../../Paylinks/components/StatusChip';
import { EventStatusDisplayValue, WebhookEventDataType } from '../types/types';
import { colorDisabled, colorError, colorSuccess, colorWarning } from '../../../util/constants';

interface Props {
  webhookEvent: WebhookEventDataType;
  isRetrying?: boolean;
  size?: 'small' | 'medium';
}

const getStatus = (status: EventStatusDisplayValue, isRetrying?: boolean) => {
  if (status === EventStatusDisplayValue.FAILURE && isRetrying) {
    return EventStatusDisplayValue.PENDING;
  }
  return status;
};

const getColor = (status: EventStatusDisplayValue) => {
  switch (status) {
    case EventStatusDisplayValue.FAILURE:
      return colorError;
    case EventStatusDisplayValue.SUCCESS:
      return colorSuccess;
    case EventStatusDisplayValue.PENDING:
      return colorWarning;
    default:
      return colorDisabled;
  }
};

const getStatusIcon = (status: EventStatusDisplayValue) => {
  switch (status) {
    case EventStatusDisplayValue.SUCCESS:
      return <Check />;
    case EventStatusDisplayValue.FAILURE:
      return <Close />;
    case EventStatusDisplayValue.PENDING:
      return <HourglassEmpty />;
    default:
      return undefined;
  }
};

export const WebhookStatusChip = ({
  webhookEvent: row,
  isRetrying,
  size = 'small',
}: Props): JSX.Element => {
  const status = getStatus(row.displayStatus, isRetrying);

  return (
    <BaseStatusChip
      color={getColor(status)}
      icon={getStatusIcon(status)}
      label={status}
      size={size}
    />
  );
};
